module.exports = __webpack_public_path__ + "img/1-3.c1da20b0.png";